import React from 'react'
import { Spinner } from 'reactstrap'

const Loading = () => (
    <Spinner />
)
export default Loading